import React, { useEffect, useState } from "react";
import CurrentLocation from "./CurrentLocation";

function App() {
  const { latitude, longitude } = CurrentLocation();

  const [Data, setData] = useState();
  const [location, setlocation] = useState({ lat: "", long: "" });
 
  const endlat = 21.2440032;
  const endlong = 72.8299872;

  useEffect(() => {
    const FetchData = async () => {
      const url = `https://router.hereapi.com/v8/routes?transportMode=car&origin=${location.lat},${location.long}&destination=${endlat},${endlong}&return=polyline,turnbyturnactions&apikey=tLlWmBrfW04rbHVJZ6Aa7Y_QTMGLmA3csfW6P3PQzXs`;
      const response = await fetch(url);
      const resJSON = await response.json();
      if (resJSON.routes !== undefined) {
        const action = resJSON.routes[0].sections[0].turnByTurnActions;
        const ActionObject = {...action[1]}
        setData(ActionObject);
      }
    };

    FetchData();
  }, [location]);

  if (latitude !== location.lat || longitude !== location.long) {
    setlocation({ lat: latitude, long: longitude });
  }
  console.log(location);

  console.log(Data);

  return (
    <>
      <div>
        {location.lat},{location.long}
      </div>
    </>
  );
}

export default App;
